<template>
    <div class="h-full w-full sticky top-0">
        <!-- {{ bulkOperationQueryParams }} -->
        <div  v-if="finishedAction" class="w-full h-full">
            <div v-if="responseStatus == 200" class="w-full h-full justify-between">
                <div v-if="bulkOperationQueryParams" class="flex flex-col justify-start items-center p-3 h-[95%]">
                     This action has been performed on all results.
                </div>
                <div v-else>
                    This action has been performed on {{ numSelectedResults }} results. 
                </div>
                <div class="h-10 flex items-center justify-center">
                    <BaseButtonCancel
                        @click="closeBulkOperationClearSelected"
                    >
                        Close
                    </BaseButtonCancel>
                </div>
            </div>
            <div v-else>
                <p>{{ title }}: Failed - Bad Request.</p>
                <br>
                <p>An error occurred that prevented the completion of this action.</p>
            </div>
        </div>
        <div v-else class="w-full h-full">
            <div v-if="isLoading">
                <svg aria-hidden="true" class="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="white"/>
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="#2E9CCA"/>
                </svg>
                <span class="sr-only">Loading...</span>
            </div>
            <div v-else class="w-full h-full">
                <div class="w-full h-full">
                    <form action="" @submit.prevent="" class="flex flex-col h-full w-full justify-between">
                        <div class="h-full overflow-y-scroll">
                            <div v-for="(inputValue, inputKey, index) in bulkAction.inputs" :key="inputKey" class="p-2 flex flex-col space-y-1">
                                <div class="tracking-wider font-medium px-1">{{ inputValue.label }}</div>
                                <div v-if="inputKey=='collectionTag'" class="flex flex-col space-y-4">
                                    <div class="">
                                        <input
                                            type="text"
                                            :id="`input-${index}`"
                                            :list="`datalist-${index}`"
                                            class="bg-white p-1 border rounded-sm w-full border-gray-300 text-gray-800 block "
                                            @change="setCollectionTagPayload"
                                        />
                                        <datalist :id="`datalist-${index}`">
                                            <option value="null">------------</option>
                                            <option v-for="option in inputValue.options" :key="option.value" :value="`${option.value}`">{{ option.label }}</option>
                                        </datalist>
                                    </div>
                                    <div class="flex flex-col space-y-1">
                                        <div class="tracking-wider font-medium px-1 pt-2 border-t border-gray-300">Selected Tags:</div>
                                        <!-- <div class="ml-1" v-if="!payload || payload.length == 0">
                                            None
                                        </div> -->
                                        <div class="flex flex-wrap">
                                            <base-pill class="hover:cursor-pointer m-1" @click="removeTag(value)" v-for="value in payload" :key="value">{{ value }} | X</base-pill>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="space-x-3 h-10 flex items-center justify-center">
                            <BaseButton type="button" @click="submitForm">Submit</BaseButton>
                            <BaseButtonCancel type="button" @click="cancelBulkOperation">Cancel</BaseButtonCancel>
                        </div>
                    </form>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch, reactive } from 'vue';
import { performBulkAction, bulkAssignQueryResultsToCollectionTag } from '@/services/Company';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import BaseButton from '../base-components/BaseButton.vue';
import BaseButtonCancel from '../base-components/BaseButtonCancel.vue';

const store = useStore()
const $toast = useToast()


const props = defineProps([
    'bulkAction',
    'selectedResults',
    'viewType',
    'dataRequest',
    'dataImports',
    'fetchFilter'
])

const emit = defineEmits([
    'cancel-bulk-operation',
    'close-bulk-operation',
    'refetch-results',
    'clear-selected-results',
])

const isLoading = ref(false);
const finishedAction = ref(false);
const response = ref(null);
const responseStatus = ref(null);
const bulkAction = reactive(props.bulkAction)
const payload = ref(null);

const title = computed(() => {
    if(props.bulkAction) {
        if(props.bulkAction.label) {
            return props.bulkAction.label
        }
    }
    return ''
});

const numSelectedResults = computed(() => {
    if(props.selectedResults){
        if(props.selectedResults.length > 0) {
            return props.selectedResults.length
        }
    }
    return 0
})

const bulkOperationQueryParams = computed(() => {
    if(props.viewType == 'imports') {
        let query = new URLSearchParams({});
        if(props.selectedResults.length == 0) {
            query.append('data_request', props.dataRequest.id)
        } else {
            props.dataImports.forEach((dataImport) => {
                query.append('data_import', dataImport.id)
            })
        }
        let url;
        let queriesCount = 0;
        for (let value of query.values()) {
            queriesCount = queriesCount + 1;
        }
        if (queriesCount > 0) {
            url = "?" + query.toString();
        } else {
            url = "?";
        }
        return url
    } else if(props.viewType == 'companies') {
        if(props.selectedResults.length == 0) {
            return props.fetchFilter
        }
    }
    return  null
})

function setCollectionTagPayload(event) {
    if(event.target.value){
        if(Array.isArray(payload.value)){
            if(!payload.value.includes(event.target.value)){
                payload.value.push(event.target.value)
            }
        } else {
            payload.value = [event.target.value]
        }
        event.target.value = null
    }
    // console.log('payload', payload.value)
}

function removeTag(tagName){
    payload.value.splice(payload.value.indexOf(tagName), 1)
}

function cancelBulkOperation() {
    console.log('cancelBulkOperation')
    emit('cancel-bulk-operation')
}

function closeBulkOperationClearSelected() {
    emit('cancel-bulk-operation')
    emit('clear-selected-results')
}

async function submitForm() {
    console.log('performBulkOperation')
    isLoading.value = true
    const token = store.state.auth.token
    const selectedCompanyIds = props.selectedResults.map(({id}) => id)
    if(payload.value === null) {
        return alert("Please make selection to proceed.")
    }
    if(bulkOperationQueryParams.value) {
        response.value = await bulkAssignQueryResultsToCollectionTag(payload.value, bulkOperationQueryParams.value, token)
    } else {
        response.value = await performBulkAction(token, selectedCompanyIds, bulkAction.endpoint, payload.value)
    }
    console.log('bulk action response')
    console.log(response.value)
    console.log(response.value.data)
    isLoading.value = false;
    finishedAction.value = true;
    responseStatus.value = response.value.status
    if(responseStatus.value == 200) {
        $toast.open({
            message:`Completed bulk operation: ${bulkAction.label}`,
            type: 'success',
            duration: 3000
        })
        emit('refetch-results')
    } else {
        $toast.open({
            message: `Could not complete bulk operation: ${bulkAction.label}`,
            type: 'error',
            duration: 10000
        })
    }
}
</script>